/** @type {BadgeEditor.ObjectPosition} */
const DefaultPosition = Object.freeze({
    top: 0,
    left: 0,
});

export const DebounceMs = Object.freeze({
    DEFAULT: 350,
});

export const DEFAULT_FONT = 'badge-printing-default-font';

/** @type {BadgeEditor.Textbox} */
export const DefaultTextbox = Object.freeze({
    text: '{{fname}}',
    fontFamily: DEFAULT_FONT,
    fill: '#000000',
    fontSize: 60,
    minFontSize: 60,
    textAlign: 'center',
    width: 609,
    height: 61,
    ...DefaultPosition,
});

/** @type {BadgeEditor.QrCode} */
export const DefaultQrCode = Object.freeze({
    content: 'DB{{_id}}-{{private_key}}',
    width: 203,
    height: 203,
    ...DefaultPosition,
});

/** @type {BadgeEditor.Image} */
export const DefaultImage = Object.freeze({
    width: 900,
    height: 240,
    id: 'placeholder',
    ...DefaultPosition,
});
